import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/contracts/')({
  loader: ({ params }) => {
    throw redirect({
      to: '/$orgId/pricing',
      params: { orgId: params.orgId },
      replace: true,
    })
  },
})
